import React from "react";
import { Fragment } from "react";
import Moment from "moment";

const TopRow = ({ loginUser }) => {
  const profileImage =
    !loginUser?.ProfilePicture ||
    loginUser?.ProfilePicture === "null" ||
    loginUser?.ProfilePicture === "undefined"
      ? require("../../../img/employee/user.png")
      : `http://13.68.220.177:63306/wwwroot/UploadedPhotos/ProfilePicture/${loginUser?.ProfilePicture}`;

  return (
    <Fragment>
      <div
        className="welcome-box"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 20px",
        }}
      >
        {/* LEFT SIDE HEADING */}
        <div>
          <h2 style={{ margin: 0 }}>Dashboard</h2>
          <small>Overview of your activities</small>
        </div>

        {/* RIGHT SIDE USER INFO */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <div style={{ textAlign: "right" }}>
            <h5 style={{ margin: 0 }}>
              {loginUser?.EmployeeName ?? ""}
            </h5>
            <span style={{ fontSize: "14px", color: "#6c757d" }}>
              {Moment(new Date()).format("dddd, MMMM Do YYYY")}
            </span>
          </div>

          <div>
            <img
              src={profileImage}
              alt="Profile"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TopRow;